import { TableCell } from '@mui/material';
import { styled } from '@mui/system';

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  borderBottom: '1px dashed' + theme.palette.divider,
}));
